// src/components/PublicRoute.js
import { Navigate, Outlet } from "react-router-dom";

const PublicRoute = () => {
  const token = localStorage.getItem("token");
  const user = (() => {
    try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
  })();

  if (token && user) {
    const redirectPath =
      user.role === "OPERATION"
        ? "/operation-dashboard"
        : user.role === "LOGISTIC"
        ? "/logistics-dashboard"
        : "/client-dashboard";

    return <Navigate to={redirectPath} replace />;
  }

  return <Outlet />;
};

export default PublicRoute; // 👈 this line is REQUIRED
